var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./bookingRespTemplate.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-0cf8b360\",\"hasScoped\":false}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./bookingRespTemplate.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/component/Pricing/bookingRespTemplate.vue
// module id = 1916
// module chunks = 0